import { WithDimension } from "./withDimension";

export type ScreenPayload = {
  id?: number,
  origin_x_cm: number,
  origin_y_cm: number,
  width_cm: number,
  height_cm: number,
  location: string,
  role: string,
  connection: string
}

export class Screen implements WithDimension {
  public id = 0;
  public origin_x_cm = 0;
  public origin_y_cm = 0;
  public width_cm = 1;
  public height_cm = 1;
  public puc_id = '';
  public location = 'front';
  public role = 'pickup';
  public connection = 'primary';
  
  static payload(args: Screen, isNew = false): ScreenPayload {
    const payload: ScreenPayload = {
      id: args.id,
      origin_x_cm: args.origin_x_cm,
      origin_y_cm: args.origin_y_cm,
      width_cm: args.width_cm,
      height_cm: args.height_cm,
      location: args.location,
      role: args.role,
      connection: args.connection
    };

    if (isNew) {
      const {id: _, ...sanitized} = payload;
      return sanitized;
    }

    return payload;
  }

  static screensPayload(args: Array<Screen>, isNew = false): Array<ScreenPayload> {
    const temp = [];
    for (const screen of args) {
      temp.push(Screen.payload(screen, isNew));
    }

    return temp;
  }
}
